import { modifierUnitsSubtotal } from './modifierQuantity'
import { flattenSelectedOptions } from './flattenSelectedOptions'
import type { GuidedStep } from './guidedSteps'
import type { GuidedState } from './guidedFlowReducer'

/**
 * Suma pura de los deltas de los modificadores SELECCIONADOS, en todos los
 * pasos. Nunca compone un total de línea: no recibe (ni suma) el precio base
 * del ítem, y no recibe la cantidad del plato — cada vista compone el total
 * real con la fórmula de su propio carrito.
 *
 * La deduplicación por `(groupId, optionId)` vive en `flattenSelectedOptions`
 * — compartida con `buildKioskCartLine`/`buildMicrositeCartLine`, para que el
 * subtotal pintado y la línea que se cobra nunca puedan divergir en cuántas
 * veces cuentan la misma opción.
 */
export function computeModifiersSubtotal(
  steps: GuidedStep[],
  selections: GuidedState['selections']
): number {
  const flat = flattenSelectedOptions(steps, selections).map(({ option, quantity }) => ({
    priceDelta: option.priceDelta,
    quantity,
  }))
  return modifierUnitsSubtotal(flat)
}
